<div [formGroup]="form" class="container">
  <div class="row">
    <div class="col-6">
      <div class="form-control">
        <mat-form-field appearance="outline" [floatLabel]="isEditMode ? 'always' : 'auto'">
          <mat-label>Card Number</mat-label>
          <input
            matInput
            #accountInput
            formControlName="account"
            [readonly]="isViewMode || isEditMode"
            [hiddenInput]="hideCardNumber && !isEditMode"
            [mask]="isEditMode ? '' : cardMask"
            [style.opacity]="isEditMode ? '0.6' : '1'"
            [style.background]="isEditMode ? '#f0f0f0' : ''"
            (paste)="onAccountPaste($event)"
          />
          @if (!isEditMode) {
          <button mat-icon-button matSuffix (click)="toggleCardVisibility()">
            <mat-icon *ngIf="hideCardNumber">visibility</mat-icon>
            <mat-icon *ngIf="!hideCardNumber">visibility_off</mat-icon>
          </button>
          }
          <mat-icon matPrefix color="primary">credit_card</mat-icon>
          <mat-error>
            @if (form.controls.account.hasError('required')) { Valid Card is required } @else if
            (form.controls.account.hasError('pattern')) { Card number is invalid } @else if
            (form.controls.account.hasError('luhnInvalid')) { Card number is invalid } @else if
            (form.controls.account.hasError('cardInvalid')) { Card number is invalid. }
          </mat-error>
        </mat-form-field>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-6">
            <div class="form-control">
              <mat-form-field appearance="outline" [floatLabel]="isEditMode ? 'always' : 'auto'">
                <mat-label>Exp. Date</mat-label>
                <input
                  matInput
                  #expirationDateInput
                  placeholder="MM YY"
                  formControlName="expirationDate"
                  [readonly]="isViewMode"
                  mask="00 00"
                  [dropSpecialCharacters]="true"
                />
                <mat-error>
                  @if (form.controls.expirationDate.hasError('required')) { required } @else if
                  (form.controls.expirationDate.hasError('pattern')) { Invalid Expiration } @else if
                  (form.controls.expirationDate.hasError('expirationDateInvalid')) { Card Expired } @else if
                  (form.controls.expirationDate.hasError('expirationDateTooFar')) { Invalid Expiration }
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6">
            <div class="form-control">
              <mat-form-field appearance="outline">
                <mat-label>CVV Code{{ requireCVV ? '' : ' (opt)' }}</mat-label>
                <input matInput #cvvInput formControlName="cvv" [readonly]="isViewMode" [mask]="cvvMask" />
                @if(enforceAVSMatch == false && showIgnoreCVV) {
                <label
                  style="
                    font-size: 11px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-top: 2px;
                  "
                >
                  <input type="checkbox" formControlName="ignoreCVV" [disabled]="isViewMode" /> Ignore
                </label>
                }
                <mat-error>
                  @if (requireCVV && form.controls.cvv.hasError('required')) { CVV required. } @if
                  (form.controls.cvv.hasError('cvvInvalid')) { Incorrect CVV. }
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          background: #f8f9fa;
          border-left: 3px solid #0d6efd;
          border-radius: 4px;
          padding: 10px 14px;
          margin-top: 4px;
          font-size: 12px;
          color: #495057;
          line-height: 1.5;
        "
      >
        <strong style="color: #0d6efd">Processing Fee Savings</strong><br />
        To help reduce your credit card processing fees, we strongly encourage collecting and entering accurate CVV and
        address verification details for every transaction.
      </div>
    </div>
    <div class="col-6">
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Card Holder Name</mat-label>
          <input matInput #cardHolderNameInput formControlName="cardHolderName" [readonly]="isViewMode" />
          <mat-error>
            @if (form.controls.cardHolderName.hasError('required')) { Card holder name is required }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Street Address</mat-label>
          <input
            matInput
            #addressInput
            formControlName="streetAddress"
            [readonly]="isViewMode || form.get('ignoreStreet')?.value"
            [style.opacity]="form.get('ignoreStreet')?.value ? '0.4' : '1'"
            [style.pointer-events]="form.get('ignoreStreet')?.value ? 'none' : 'auto'"
            (blur)="onStreetBlur()"
            (input)="onStreetInput()"
          />
          @if(showIgnoreStreet) {
          <label
            style="font-size: 11px; cursor: pointer; display: flex; align-items: center; gap: 4px; margin-top: 2px"
          >
            <input type="checkbox" formControlName="ignoreStreet" [disabled]="isViewMode" /> Ignore
          </label>
          }
          <mat-error>
            @if (form.controls.streetAddress.hasError('required')) { Street address is required. } @else if
            (form.controls.streetAddress.hasError('maxlength')) { Address cannot exceed 50 characters. } @else if
            (form.controls.streetAddress.hasError('streetInvalid')) { Address verification failed. }
          </mat-error>
        </mat-form-field>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-6">
            <div class="form-control">
              <mat-form-field appearance="outline" [floatLabel]="isEditMode ? 'always' : 'auto'">
                <mat-label>Zip Code</mat-label>
                <input
                  matInput
                  #zipInput
                  formControlName="zipCode"
                  [readonly]="isViewMode"
                  mask="00000"
                  maxlength="5"
                />
                @if(enforceAVSMatch == false && showIgnoreZip) {
                <label
                  style="
                    font-size: 11px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-top: 2px;
                  "
                >
                  <input type="checkbox" formControlName="ignoreZip" [disabled]="isViewMode" /> Ignore
                </label>
                }
                <mat-error>
                  @if (form.controls.zipCode.hasError('required')) { required. } @else if
                  (form.controls.zipCode.hasError('pattern')) { Bad Zip. } @else if
                  (form.controls.zipCode.hasError('minlength')) { Bad Zip. } @else if
                  (form.controls.zipCode.hasError('maxlength')) { Bad Zip. } @else if
                  (form.controls.zipCode.hasError('zipInvalid')) { Bad Zip. }
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6">
            <div class="form-control">
              @if (!hideDefaultOption) {
              <mat-slide-toggle
                formControlName="isDefault"
                [checked]="form.get('isDefault')?.value"
                [disabled]="isViewMode"
              >
                set as default
              </mat-slide-toggle>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="form-control-group">
        @if(isVerificationPending) {
        <div style="display: flex; align-items: center; gap: 8px; color: #0d6efd; font-size: 13px; padding: 4px 0">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; animation: spin 1s linear infinite"
            >sync</mat-icon
          >
          Verifying card...
        </div>
        } @else {
        <mat-error>
          @if(this.isCardValidated) {
          <span style="color: green">{{ invalidMessage }}</span>
          } @else {
          {{ invalidMessage }}
          }
        </mat-error>
        @if(showVerifyCardButton) {
        <div style="margin-top: 8px">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="onVerifyCardClick()"
            style="height: 44px; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; line-height: normal"
          >
            <mat-icon style="margin: 0; overflow: visible">verified_user</mat-icon>
            <span>Verify Card</span>
          </button>
        </div>
        }
        }
      </div>
    </div>
  </div>
</div>
